import { AuthService } from './../../../services/user/auth.service';
import { CompaniesService } from './../../../services/company/companies.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AssociationsService } from 'app/services/associations/associations.service';
import { ConfirmationService, SelectItem } from 'primeng/components/common/api';
import { Observable } from 'rxjs/Observable';
import { User, UserCompany, UserComplex } from '../../../models/user.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { RolesService } from '../../../services/user/roles.service';
import { UsersService } from '../../../services/user/users.service';
import { LoggedInUser } from 'app/models/loggedinuser.model';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';

@Component({
  providers: [],
  templateUrl: 'users.component.html',
  styles: ['#user-dialog ::ng-deep .ui-dialog {top: 40% !important; transform: translateY(-40%) !important;}']
})

export class UsersComponent implements OnInit {

  companies: SelectItem[] = [{value: 1, label: 'Coop'}, {value: 2, label: 'Pam'}];
  customButtons: DataTableCustomButton[];
  userSelected: User = null;
  selectedCompanies: UserCompany[] = [];
  newDataAvailable = false;
  showDialog = false;
  showPswDialog = false;
  comboOptions = [] = [ {label: 'All', value: null} ];
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  dialogCompanies = false;
  dialogTitlesList: any = {};
  dialogTitle: string;
  usersList;
  paginationType = KontableComponent.ServerPagination;
  userId: number;
  showAssociateDialog: boolean;
  user: User;
  userToClone: {id: number; roleId: number; companies: number[]};
  userData : any;

  constructor (
    public srvUsers: UsersService,
    public srvDataTable: DataTableService,
    public translate: TranslateService,
    public srvRoles: RolesService,
    public confirmationService: ConfirmationService,
    public associationsService: AssociationsService,
    private srvCompany: CompaniesService,
    public authService: AuthService,
    private srvLocalStorage: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit(): void {

   const translateGet = this.translate.get([
      'users.add_title',
      'users.edit_title'
    ]);
    if (this.srvLocalStorage.get('userData')) {
      this.userData = this.srvLocalStorage.get('userData');
    } else if (sessionStorage.getItem('userData')) {
      this.userData = JSON.parse(sessionStorage.getItem('userData'));
    }
    //this.userData = JSON.parse(sessionStorage.getItem('userData'));
    const rolesGetAll = this.srvRoles.getAll();
    Observable.zip(
      translateGet,
      rolesGetAll,
    ).subscribe(([resTranslate, resRolesGetAll]) => {
      this.dialogTitlesList.add_title = resTranslate['users.add_title' ];
      this.dialogTitlesList.edit_title = resTranslate['users.edit_title'];

      resRolesGetAll.forEach((r) => {
          this.comboOptions.push({label: r.descr, value: r.descr});
      });
    });
  }

  showAddOrEditDialog(data): void {
    let uc = new UserComplex();
    uc.user = (data) ? data : new User();
    this.dialogTitle = data ? this.dialogTitlesList.edit_title : this.dialogTitlesList.add_title;
    this.srvUsers.userEditing = uc;
    this.showDialog = true;
  }

  delete(record): void {
    this.srvUsers.delete(record).subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  userAdded(row): void {
    row.user.email = row.user.email.toLowerCase ();
    if (this.userToClone) {
      this.srvUsers.clone(row, this.userToClone.id).subscribe(() => {
        this.refreshDataAndCloseDialog();
      });
    } else {
      this.srvUsers.post(row).subscribe(() => {
        this.refreshDataAndCloseDialog();
      });
    }
  }

  refreshDataAndCloseDialog() {
    this.srvDataTable.get('dt_users').showDetail = false;
    this.srvUsers.userEditing = null;
    this.srvUsers.getList().subscribe();
    this.newDataAvailable = true;
    this.closeDialog();
  }

  userUpdated(row): void {
    row.user.email = row.user.email.toLowerCase ();
    this.srvUsers.put(row).subscribe(() => {
      this.srvDataTable.get('dt_users').showDetail = false;
      this.srvUsers.userEditing = null;
      this.newDataAvailable = true;
      this.closeDialog();
    })
  }

  companiesAction (event) {
    this.userSelected = event;
    this.srvUsers.getUserCompanies(this.userSelected).subscribe().add(() => {
      this.selectedCompanies = this.srvUsers.userCompanies;
      this.dialogCompanies = true;
    });
  }

  resetPwdAction (event) {
    this.translate.get(['userList.resetPasswordConfirmDescr', 'userList.resetPasswordConfirmHeader']).subscribe((res) => {
      this.confirmationService.confirm({
        message: res['userList.resetPasswordConfirmDescr'],
        header: res['userList.resetPasswordConfirmHeader'],
        accept: () => {
          this.srvUsers.newResetPassword(this.userId, event).subscribe(() => this.showPswDialog = false);
        }
      });
    });
  }

  openPswResetDialog(row: User) {
    this.showPswDialog = true;
    this.userId = row.id;
  }

  closeDialog() {
    this.showDialog = false;
    this.userToClone = null;
  }

  openAssociate(row: User) {
    this.associationsService.rowId = row.id;
    this.user = row;
    this.showAssociateDialog = true;
  }

  openCloneUserDialog(row) {
    const userCompanies = [];
    this.srvCompany.getUserCompanies(row.id).subscribe(res => res.forEach(company => userCompanies.push(company.company_id)));
    this.userToClone = {id: row.id, roleId: row.role_id, companies: userCompanies};
    let uc = new UserComplex();
    uc.user = new User();
    this.srvUsers.userEditing = uc;
    this.showDialog = true;
  }

  openImpersonification(row) {
    this.confirmationService.confirm({
      message: this.translate.instant('userForm.impersonificationMessage'),
      header: this.translate.instant('userForm.impersonification'),
      accept: () => this.loginOther(row),
      acceptLabel: this.translate.instant('common.yes'),
      rejectVisible: true,
      rejectLabel: this.translate.instant('common.no'),
      reject: () => false
    })
  }

  loginOther(row) {
    let data = {'username': row.login}

    this.srvUsers.impersonificaUtente(data).subscribe(res => {
      if (this.srvLocalStorage.get('userData')) {
        this.userData = this.srvLocalStorage.get('userData');
      } else if (sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(sessionStorage.getItem('userData'));
      }

      this.userData.id = res.user_id;
      this.userData.login = row.login
      this.userData.firstName = row.name;
      this.userData.lastName = row.surname;
      this.userData.token = res.access_token;
      this.userData.refreshToken = res.access_token;
      this.authService.user.id = res.user_id;
      this.authService.user.refreshToken = res.access_token;
      this.authService.user.token = res.access_token;

      this.srvUsers.getApplicationsForUserCompany(this.authService.user.id, this.authService.user.selectedCompany).subscribe(
        res => {
          this.translate.reloadLang(this.translate.currentLang);
          this.authService.user.enabledUserApps = res;
          this.userData.enabledUserApps = res;
          this.userData.enabledApplications = [];
          res.forEach(app => {
            this.userData.enabledApplications.push(app.application_id)
          })

          this.srvLocalStorage.remove('userData');
          sessionStorage.removeItem('userData');
          this.srvLocalStorage.set('userData', this.userData);
          sessionStorage.setItem('userData', JSON.stringify(this.userData));

          sessionStorage.removeItem('menu');

          this.router.navigate(['/dashboard'])
          .then(() => {
            window.location.reload();
          });
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/users/users.component.ts